import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import clsx from 'clsx';
import getImageUrl from '@configuratorware/configurator-frontendgui/App/Utils/getImageUrl';

const useStyles = makeStyles((theme) => ({
  filterContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2, 0, 1, 0),
    borderTop: '1px solid #9e9e9e',
    borderBottom: '1px solid #9e9e9e',
    margin: '8px 2px 16px 12px',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1, 0, 1, 0),
    },
  },
  filter: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  filterItem: {
    width: '100%',
    minWidth: 32,
    borderRadius: 0,
    padding: theme.spacing(1.5),
    margin: 0,
    justifyContent: 'flex-start',
    textAlign: 'left',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& img': {
      maxWidth: '100%',
      aspectRatio: 1,
      [theme.breakpoints.down('md')]: {
        maxWidth: 45,
      },
    },
    [theme.breakpoints.down('md')]: {
      padding: 2,
    },
  },
  selected: {
    color: theme.palette.primary.main,
  },
  buttonLabel: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'flex-start',
    '& > span': {
      lineHeight: 1.2,
      textTransform: 'none',
      fontSize: '0.875rem',
      fontWeight: 'bold',
      [theme.breakpoints.down('md')]: {
        fontSize: '0.7rem',
      },
    },
  },
  filterTitle: {
    marginLeft: 12,
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      marginBottom: 4,
    },
  },
  smallMode: {
    '& $filterContainer': {
      padding: theme.spacing(1, 0, 1, 0),
    },
    '& $filterItem': {
      padding: 2,
      '& img': {
        maxWidth: 45,
      },
    },
    '& $buttonLabel': {
      '& > span': {
        fontSize: '0.7rem',
      },
    },
    '& $filterTitle': {
      marginLeft: 0,
      marginBottom: 4,
    },
  },
}));

export const Filter = ({ items, onSelect, value, className, smallMode }) => {
  const classes = useStyles();
  if (!items || !items.length) {
    return null;
  }
  return (
    <div className={clsx(classes.filterContainer, smallMode && classes.smallMode, className)}>
      <Typography color="inherit" className={classes.filterTitle}>
        {t('filter.filterHeader')}
      </Typography>
      <div className={classes.filter}>
        {items.map((item) => (
          <div key={item.id}>
            <Button
              m={1}
              className={clsx(classes.filterItem, value === item && classes.selected)}
              onClick={() => onSelect(item)}
              classes={{ label: classes.buttonLabel }}
            >
              {item.thumbnail && <img src={getImageUrl(item.thumbnail)} alt={item.translated_value} />}
              <Typography color="inherit" variant="caption">
                {item.translated_value}
              </Typography>
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

Filter.propTypes = {
  items: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
  className: PropTypes.string,
  smallMode: PropTypes.bool,
};

export default Filter;
